<dff-side>
    <empty-page-badge svgIcon="404" overskrift="404 - Siden findes ikke">
        <p>Du er kommet til en side, som ikke findes.</p>
    </empty-page-badge>
</dff-side>
